export default "__VITE_ASSET__w$s2C8yR__"